import omit from 'lodash/omit';

import {
  NoteStateMapV510,
  NoteStateV510,
} from 'src/common/store/migrate/types/5.1.0';
import { NotebookState } from 'src/common/store/notebook/NotebookState';
import { safelyGet } from 'src/common/utils/safelyGet';
import { InitialData } from 'src/types';

// eslint-disable-next-line import/no-default-export
export default (data: InitialData) => {
  const oldNotebook: Partial<NotebookState> = safelyGet(data, ['notebook'], {});
  const oldNotes: NoteStateMapV510 = safelyGet(oldNotebook, ['notes'], {});
  const newNotes: NoteStateMapV510 = Object.entries(oldNotes).reduce(
    (acc, [noteId, note]) => {
      const newNote: NoteStateV510 = {
        ...note,
        editorSettings: omit(note.editorSettings, 'moduleId'),
      };
      acc[noteId] = newNote;
      return acc;
    },
    {}
  );

  return {
    ...data,
    version: '4.5.0',
    notebook: {
      ...oldNotebook,
      notes: newNotes,
    },
  };
};
